'use client';

import type { ReactNode } from 'react';
import type { ToolUIPart } from 'ai';

export type ToolPartCustomRendererArgs = {
  toolName: string;
  toolCallId: string;
  state: ToolUIPart['state'];
  input: unknown;
  output?: unknown;
};

export type ToolPartCustomRenderer = (args: ToolPartCustomRendererArgs) => ReactNode;

export interface ToolPartProps extends ToolPartCustomRendererArgs {
  customRenderer?: ToolPartCustomRenderer;
}

/**
 * A tool call in the transcript. Progress is narrated by the status line, so a
 * tool contributes nothing here unless it renders UI of its own.
 */
export function ToolPart({ customRenderer, ...args }: ToolPartProps) {
  return customRenderer?.(args) ?? null;
}
